export class cAdminUser {
  input_userLogin =  document.querySelector('#user_login') as HTMLInputElement;
  input_userEmail =  document.querySelector('#email')      as HTMLInputElement;

  constructor() {
    const parent = document.querySelector('.c-admin-user') as HTMLDivElement;
    if (!parent) {
      return;
    }

    this.input_userEmail.addEventListener('change', () => {
      this.input_userLogin.value = this.input_userEmail.value;
    });
  }
}